import { render, staticRenderFns } from "./ResearchPheWasPlotVector.vue?vue&type=template&id=2683433a&"
import script from "./ResearchPheWasPlotVector.vue?vue&type=script&lang=js&"
export * from "./ResearchPheWasPlotVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2683433a')) {
      api.createRecord('2683433a', component.options)
    } else {
      api.reload('2683433a', component.options)
    }
    module.hot.accept("./ResearchPheWasPlotVector.vue?vue&type=template&id=2683433a&", function () {
      api.rerender('2683433a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchPheWasPlotVector.vue"
export default component.exports